import React from 'react';
import { Button } from '@beehive/components';
import DotDotDot from '@mpc/common/src/components/DotDotDot';
import './index.less';

type Item = {
  fileName: string;
  size: string;
  link: string;
  id: number;
};

const AttachDownloadItem = (props: Item) => {
  const { fileName, size, link } = props;
  const prefixCls = 'detail-bottom-attach-download-item';

  return (
    <div className={prefixCls}>
      <DotDotDot clamp={1} className={`${prefixCls}-name`}>
        {fileName}
      </DotDotDot>
      <span className={`${prefixCls}-size`}>（{size}）</span>
      <Button link href={link} target="_blank">
        下载
      </Button>
    </div>
  );
};

type List = {
  list: Item[];
};

export const AttachDownloadList: any = (props: List) => {
  const { list = [] } = props;
  const prefixCls = 'detail-bottom-attach-download-list';

  if (!list.length) return '--';

  return (
    <div className={prefixCls}>
      {list.map((v, i) => {
        return (
          <div className={`${prefixCls}-wrap`} key={v.id}>
            <span>{i + 1}、</span>
            <AttachDownloadItem {...v} />
          </div>
        );
      })}
    </div>
  );
};

export default AttachDownloadItem;
